import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DashboardsModule } from '@uigy/modules/dashboards/dashboards.module';
import { ChartParams, CustomDashboard } from '@uigy/modules/dashboards/models/interfaces';
import { DashboardsInventoryService } from '@uigy/modules/dashboards/services/dashboards-inventory.service';
import { DashboardsService } from '@uigy/modules/dashboards/services/dashboards.service';
import { RoutesStatesNamesEnum } from '@uigy/shared/enums/routesStatesNames.enum';
import { MaterialModule } from '@uigy/shared/material-module/material.module';
import { LanguageService } from '@uigy/shared/services/language.service';
import { HeadingComponent } from '@uigy/shared/components/heading/heading.component';
import { I18NextModule } from 'angular-i18next';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Component({
    selector: 'app-most-recent-events',
    imports: [
        CommonModule,
        DashboardsModule,
        MaterialModule,
        I18NextModule,
        HeadingComponent,
    ],
    templateUrl: './most-recent-events-page.component.html',
    styleUrl: './most-recent-events-page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MostRecentEventsPageComponent implements OnInit {
  public readonly emptyText = this.languageService.texts.general.empty_state.no_items_found;
  public readonly pageTexts = this.languageService.texts.dashboards.widgets.mostrecentevents;
  public mostRecentEvents$?: Observable<ChartParams[] | undefined>;
  public emptyState: boolean = false;

  constructor(
    private languageService: LanguageService,
    private dashboardsInventoryService: DashboardsInventoryService,
    private dashboardsService: DashboardsService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    const dashboard = this.dashboardsInventoryService.customDashboards.get(RoutesStatesNamesEnum.mostRecentEvents);
    if (!dashboard) {
      return;
    }

    this.mostRecentEvents$ = this.dashboardsService.watchAndPopulateCustomDashboard(dashboard).pipe(
      take(1),
      map((res: CustomDashboard) => res.iemCharts),
      tap(() => this.cdr.detectChanges()),
    );
  }

  public onChartEmpty(): void {
    this.emptyState = true;
    this.cdr.detectChanges();
  }
}
